// extracted by mini-css-extract-plugin
module.exports = {"root":"CommentPins_root__gjuJ1","content":"CommentPins_content__1uK0V","text":"CommentPins_text__MCc53"};